export enum AccessAdministrationMutation {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mutations: any = {}

export default mutations
